import { c as _c } from "react-compiler-runtime";
import { List, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { Fragment, memo } from 'react';

// @ts-ignore - Remove once type definitions are available
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import { TYPICAL_RESPONSE_TIME } from '../../../typical-response-time/constants/messageTypes';
// @ts-ignore - Remove once type definitions are available
import { areMessagesGrouped } from '../../../message-history/operators/areMessagesGrouped';
import { getFileAttachmentsForMessage } from '../../../message-history/operators/getFileAttachmentsForMessage';
// @ts-ignore - Remove once type definitions are available
import { getMessageId } from '../../../message-history/operators/getMessageId';
// @ts-ignore - Remove once type definitions are available
import { getPositionDescriptors } from '../../../message-history/operators/getPositionDescriptors';
import MessageHistoryItem from './MessageHistoryItem';
import { useMessageHistoryPerformanceMeasurement } from '../../../performance-metrics/hooks/useMessageHistoryPerformanceMeasurement';
import { getHiddenBy } from '../../../common-message-format/operators/commonMessageGetters';
import { LAST } from '../../../constants/messagePositionDescriptors';
import { jsx as _jsx } from "react/jsx-runtime";
function MessageHistoryCoreComponent(t0) {
  const $ = _c(24);
  const {
    channelName,
    fileAttachmentsMap,
    friendlyNames,
    getAdditionalPositionDescriptors: t1,
    historyConfig,
    lastMessageId,
    recipientsMap,
    messages,
    presentSenderLocators: t2,
    senders,
    slots,
    threadId,
    visitorLastReadTimestamp,
    visitorRecipients
  } = t0;
  const getAdditionalPositionDescriptors = t1 === undefined ? _temp : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const presentSenderLocators = t3;
  let t4;
  if ($[2] !== lastMessageId || $[3] !== messages || $[4] !== threadId) {
    t4 = {
      componentName: "MessageHistoryCore",
      propsToTrack: {
        threadId,
        messages,
        lastMessageId
      }
    };
    $[2] = lastMessageId;
    $[3] = messages;
    $[4] = threadId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useMessageHistoryPerformanceMeasurement(t4);
  let t5;
  if ($[6] !== messages) {
    t5 = (message, index) => {
      const nextNextMessage = messages === null || messages === void 0 ? void 0 : messages.get(index + 2);
      if (nextNextMessage && areMessagesGrouped(message, nextNextMessage)) {
        return true;
      }
      return false;
    };
    $[6] = messages;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const getDontIncludeLastInGroup = t5;
  let t6;
  if ($[8] !== channelName || $[9] !== fileAttachmentsMap || $[10] !== friendlyNames || $[11] !== getAdditionalPositionDescriptors || $[12] !== getDontIncludeLastInGroup || $[13] !== historyConfig || $[14] !== lastMessageId || $[15] !== messages || $[16] !== presentSenderLocators || $[17] !== recipientsMap || $[18] !== senders || $[19] !== slots || $[20] !== threadId || $[21] !== visitorLastReadTimestamp || $[22] !== visitorRecipients) {
    const additionalPositionDescriptors = getAdditionalPositionDescriptors(messages || List()) || ImmutableMap();
    t6 = messages === null || messages === void 0 ? void 0 : messages.map((message_0, index_0) => {
      const previousMessage = index_0 > 0 ? messages.get(index_0 - 1) : undefined;
      const nextMessage = messages.get(index_0 + 1);
      let dontIncludeLastInGroup;
      if (getType(nextMessage) === TYPICAL_RESPONSE_TIME) {
        dontIncludeLastInGroup = getDontIncludeLastInGroup(message_0, index_0);
      }
      const fileAttachmentsForMessagePlain = fileAttachmentsMap ? getFileAttachmentsForMessage(message_0, fileAttachmentsMap) : undefined;
      let positionDescriptors = getPositionDescriptors(message_0, previousMessage, nextMessage, dontIncludeLastInGroup);
      const messageId = getMessageId(message_0);
      const hiddenBy = getHiddenBy(message_0);
      positionDescriptors = positionDescriptors.merge(additionalPositionDescriptors.get(messageId, ImmutableSet()));
      const isLastMessage = lastMessageId === getMessageId(message_0) || positionDescriptors.includes(LAST);
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsx(MessageHistoryItem, {
          hiddenBy: hiddenBy,
          historyConfig: historyConfig,
          fileAttachmentsForMessage: fileAttachmentsForMessagePlain,
          fileAttachmentsMap: fileAttachmentsMap,
          friendlyNames: friendlyNames,
          positionDescriptors: positionDescriptors,
          message: message_0,
          senders: senders,
          presentSenderLocators: presentSenderLocators,
          visitorLastReadTimestamp: visitorLastReadTimestamp,
          visitorRecipients: visitorRecipients,
          threadId: threadId,
          recipientsMap: recipientsMap,
          channelName: channelName,
          slots: slots,
          isLastMessage: isLastMessage
        })
      }, messageId);
    });
    $[8] = channelName;
    $[9] = fileAttachmentsMap;
    $[10] = friendlyNames;
    $[11] = getAdditionalPositionDescriptors;
    $[12] = getDontIncludeLastInGroup;
    $[13] = historyConfig;
    $[14] = lastMessageId;
    $[15] = messages;
    $[16] = presentSenderLocators;
    $[17] = recipientsMap;
    $[18] = senders;
    $[19] = slots;
    $[20] = threadId;
    $[21] = visitorLastReadTimestamp;
    $[22] = visitorRecipients;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}
function _temp() {
  return ImmutableMap();
}
MessageHistoryCoreComponent.displayName = 'MessageHistory';
const MessageHistoryCore = /*#__PURE__*/memo(MessageHistoryCoreComponent);
export default MessageHistoryCore;